import { Component } from "react";
import { supabase } from "../supabase";

// Without this, a single unexpected error anywhere in the tree unmounts the
// whole app and leaves the user staring at a blank white screen with no way
// back except knowing to manually reload.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.log("APP CRASH:", error, info);

    // console.log alone means a real user's crash is invisible to us —
    // best-effort log to Supabase so it actually shows up somewhere we can
    // see it. Includes who hit it (when logged in) so a crash can be
    // correlated with a support message. Never let a logging failure
    // compound the original crash.
    (async () => {
      let userId = null;
      try {
        const { data } = await supabase.auth.getSession();
        userId = data.session?.user?.id || null;
      } catch {}

      await supabase.from("client_errors").insert({
        user_id: userId,
        message: String(error?.message || error).slice(0, 2000),
        stack: error?.stack ? String(error.stack).slice(0, 5000) : null,
        component_stack: info?.componentStack ? String(info.componentStack).slice(0, 5000) : null,
        url: window.location.href.slice(0, 500)
      });
    })().catch(() => {});
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={page}>
          <p style={heading}>Something went wrong.</p>
          <p style={subtext}>Please refresh the page and try again.</p>
          <button style={button} onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

const page = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
  textAlign: "center",
  background: "var(--bg-page, #fff)",
  fontFamily: "Arial, sans-serif",
};

const heading = { fontSize: 18, fontWeight: 700, color: "var(--text-heading, #222)", margin: "0 0 6px" };
const subtext = { fontSize: 14, color: "var(--text-muted, #777)", margin: "0 0 18px" };

const button = {
  padding: "10px 22px",
  borderRadius: 10,
  border: "none",
  background: "var(--accent-primary, #a0522d)",
  color: "#fff",
  fontWeight: 700,
  fontSize: 14,
  cursor: "pointer",
};
